export type HSCodeState = 'not_added' | 'auto' | 'history' | 'manual' | 'confirmed' | 'customer';

export const hsCodeColors: {
  [key in HSCodeState]: string;
} = {
  manual: '🔵',
  customer: '🟠',
  history: '⚪',
  confirmed: '🟢',
  not_added: '⚫',
  auto: '🔴',
};

export enum PartType {
  Standard = 'standard',
  Mold = 'mold',
}
